import { render } from "./Lens.vue?vue&type=template&id=2077efba"
import script from "./Lens.vue?vue&type=script&lang=js"
export * from "./Lens.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Lens.vue"]])

export default __exports__